import WoocommerceResource from "../../resources/woocommerce-resource"

export const makeWoocommerceResource = (): WoocommerceResource => {
    return new WoocommerceResource()
}
